import { createContext, use } from "react";

import { noop } from "@bokio/shared/utils";

export type ScrollAreaContextType = {
	scrollToTop: () => void;
};

export const ScrollAreaContext = createContext<ScrollAreaContextType>({
	scrollToTop: noop,
});

export const useScrollAreaContext = () => use(ScrollAreaContext);
